import React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';

import { selectSuggestedFeatures } from '../../store/search';
import SearchResultButton from '../search-result-button/SearchResultButton';
import AddPlaceButton from '../add-place-button/AddPlaceButton';
import './SearchResults.scss';
import { getItemDisplayName } from '../../utils/helpers/item';

export interface SearchResultsProps {
  className?: string;
  noResults?;
  showAddPlaceWhen;
  showIndexes?: boolean;
}

const SearchResults = ({
  className,
  noResults,
  showAddPlaceWhen,
  showIndexes = false,
}: SearchResultsProps) => {
  const features = useSelector(selectSuggestedFeatures);
  if (features === null) {
    return null;
  }

  const showAddPlace =
    showAddPlaceWhen === 'always' ||
    (showAddPlaceWhen === 'empty' && features && !features.length);

  const noResultsView =
    noResults === undefined ? (
      <li className="search-results__empty-result">No results found</li>
    ) : (
      noResults
    );
  return (
    <>
      <ul className={classnames('search-results', className)}>
        {features.length
          ? features.map((feature, index) => {
              const { description, mapbox_id, internal_id } =
                feature.properties;
              const displayName = getItemDisplayName(feature);
              return (
                <li
                  key={`${mapbox_id}_${internal_id}_${displayName}`}
                  className="search-results__result"
                >
                  <SearchResultButton
                    item={feature}
                    index={index}
                    className="search-results__result-button"
                  >
                    {showIndexes && (
                      <span className="search-results__result-index">
                        {index + 1}.
                      </span>
                    )}
                    <div className="search-results__result-text">
                      <div
                        className="search-results__result-title"
                        title={displayName}
                      >
                        {displayName}
                      </div>
                      <div
                        className="search-results__result-details"
                        title={description}
                      >
                        {description}
                      </div>
                    </div>
                  </SearchResultButton>
                </li>
              );
            })
          : noResultsView}
      </ul>
      {showAddPlace && (
        <AddPlaceButton className="search-results__add-place-button" />
      )}
    </>
  );
};

export default SearchResults;
